import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
    selector: 'app-excel-table-editor',
    templateUrl: './excel-table-editor.component.html',
    styleUrls: ['./excel-table-editor.component.scss'],
    standalone: false
})
export class ExcelTableEditorComponent implements OnInit, OnChanges {
  @Input() excelDataList: any[] = [];

  @Output() onSave = new EventEmitter<any>();

  displayedColumns: string[] = [];
  editingIndex: number | null = null;
  tempRow: any = {};

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['excelDataList'] && this.excelDataList?.length > 0) {
      this.displayedColumns = Object.keys(this.excelDataList[0]).filter(
        (column) =>
          column.toLowerCase() !== 'position_details' &&
          column.toLowerCase() !== 'actions'
      );

      this.excelDataList.forEach((row: any) => {
        if (row.execution_date) {
          const formatted = this.formatDateString(row.execution_date);
          if (formatted) {
            row.execution_date = formatted;
          }
        }
      });
    }
  }

  ngOnInit(): void {}

  formatDateString(value: any): string | null {
    let date: Date | null = null;

    if (typeof value === 'string' && value.includes('-')) {
      const [day, month, year] = value.split('-').map(Number);
      date = new Date(year, month - 1, day);
    } else if (!isNaN(value) && String(value).length >= 10) {
      const epoch = Number(value);
      date = new Date(epoch < 1e12 ? epoch * 1000 : epoch);
    }

    if (date && !isNaN(date.getTime())) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }

    return null;
  }

  editRow(index: number) {
    this.editingIndex = index;
    this.tempRow = { ...this.excelDataList[index] };
  }

  saveRow() {
    this.editingIndex = null;
    this.tempRow = {};
    this.onSave.emit(this.excelDataList);
  }

  cancelEdit() {
    if (this.editingIndex !== null) {
      this.excelDataList[this.editingIndex] = { ...this.tempRow };
    }
    this.editingIndex = null;
    this.tempRow = {};
  }
}
